import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { MainService } from 'app/resources/services/index';

@Component({
  selector: 'app-pedido',
  templateUrl: './pedido.component.html'
})
export class PedidoComponent implements OnInit {

  constructor(public mainService: MainService, public router: Router) { }

  ngOnInit() {
    window.scrollTo(0, 0);
  }

}



// WEBPACK FOOTER //
// ./src/app/loja/pedido/pedido.component.ts